<template>
    <div class="deliverable-dates project-dates">
        <div class="deliverable-dates__started">
            <strong class="dates-title">STARTED</strong><br>
            <span class="dates-value">{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}</span>
        </div>
        <div class="deliverable-dates__status">
            <strong class="dates-title">DUE ON</strong><br>
            <span class="dates-value" v-if="deliverable.due_date">{{ deliverable.due_date | moment("DD MMM, YYYY") }}</span>
            <span class="dates-value" v-else>Not Set</span>
        </div>
        <ProjectColor :project="deliverable" />
        <!-- <div class="deliverable-dates__status">
            <strong class="dates-title">LAST MODIFIED</strong><br>
            <span class="dates-value">{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}</span>
        </div> -->
    </div>
</template>

<script>
import ProjectColor from './ProjectColor';
import DeliverableTypeIcon from './DeliverableTypeIcon';

export default {
    components: {
        ProjectColor,
        DeliverableTypeIcon
    },
    props: ['deliverable'],
    // mounted() {
    //     this.$root.$on('collapseToggleUpdatedRoot', function() {
    //         $('.deliverable-block').each(function(i, obj) {
    //             if($(this).find('.dbox-right-side .collapse-control').hasClass('collapsed')) {
    //                 $(this).find('.deliverable-status-overview').hide();
    //                 $(this).find('.deliverable-dates').css('padding-top', 0);
    //             } else {
    //                 $(this).find('.deliverable-status-overview').show();
    //                 $(this).find('.deliverable-dates').css('padding-top', '15px');
    //             }
    //         });    
    //     });
    // }
};
</script>

<style>
</style>